import type { PropsWithChildren } from "react";

import { Group, Radio, type RadioCardProps } from "@mantine/core";

import classes from "./RadioButton.module.css";

type RadioButtonProps = PropsWithChildren<RadioCardProps>;

export function RadioButton({ children, value, ...rest }: RadioButtonProps) {
    return (
        <Radio.Card p="xs" className={classes.radioButton} value={value} radius="md" {...rest}>
            <Group className={classes.overflow}>
                <Radio.Indicator color="primary.4" size="xs" />
                {children}
            </Group>
        </Radio.Card>
    );
}
